export const HEADER_HEIGHT = '56px';

// nav z-index constants
export const Z_INDEX_TOP_NAV = 10;
export const Z_INDEX_SIDE_NAV = 100;

// local storage key storing side nav state as toggled by user
export const SIDE_NAV_EXPANDED_STORAGE_KEY = 'panther.sideNavigation.isExpanded';

// local storage key for AI sidepanel width
export const AI_SIDEPANEL_WIDTH_STORAGE_KEY = 'panther.aiSidepanel.width';

export const COLLAPSED_SIDE_NAVIGATION_WIDTH = 72;
export const EXPANDED_SIDE_NAVIGATION_WIDTH = 256;

// Left offset that centers an element of width `size` on the collapsed rail's axis, so
// every collapsed row/icon/avatar lines up on one vertical line.
export const railCenterOffset = (size: number) =>
  `${(COLLAPSED_SIDE_NAVIGATION_WIDTH - size) / 2}px`;

// Icon (asset) size for nav rows, group headers, and the profile/collapse controls (Figma asset base).
export const NAV_ICON_SIZE = 18;

// Square row size shared by primary nav rows and the collapse control (side-nav-sm).
export const NAV_ROW_SIZE = 40;
